<script lang="ts" setup>
import type { BaseItem } from '~/models/Content/BaseItem'
import CardRenderer from '~/components/cards/CardRenderer.vue'

defineProps<{ resource: BaseItem }>()
</script>

<template>
  <CardRenderer :resource="resource" />
</template>
